import { UserRole } from '../../../shared/enums';

const PermissionsOfMyAccount = {
  SeeMyPackageColumn: [UserRole.CUSTOMER],
  SeeMyPaymentsColumn: [UserRole.CUSTOMER],
  SeePreferredCompletionDate: [],
  SeeOwnAccountAsWriter: [UserRole.WRITER],
};

export default PermissionsOfMyAccount;
